import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavItem, NavEntryPoint } from '@retailer-platform/dashboard/routing'
import { loyaltyRouter } from './routing/loyaltyRouter'
import { loyaltyPartnerScopedRouter } from './routing/loyaltyPartnerScopedRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { loyaltyAccessControl } from './access-control/loyaltyAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'loyalty',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'loyalty-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  routers: {
    scoped: [loyaltyRouter],
    partnerScoped: [loyaltyPartnerScopedRouter],
  },
  navigationEntries: [
    {
      attachTo: NavItem.Merchandising,
      attachToV2: NavEntryPoint.Merchandising,
      subNavItems: [
        {
          type: 'item',
          labelId: 'loyaltyDomain.navigation.loyaltyPrograms',
          route: 'loyalty-list',
          accessControl: loyaltyAccessControl,
          positionNavV2: 10, // Position in the merchandising section
        },
      ],
    },
  ],
  adminNavigationEntries: [],
  // NOTE TO DEV: run `yarn ipp domain register <your-system-name>` to register your domain with Totem here
}

export default definition
